import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";

export default function FAQAccordion({ faqs = [], testid = "faq-accordion" }) {
  if (!faqs.length) return null;
  return (
    <Accordion type="single" collapsible data-testid={testid} className="space-y-3">
      {faqs.map((f, i) => (
        <AccordionItem key={f.id || i} value={`item-${i}`}
          className="card-site !rounded-2xl px-6 border-black/5 overflow-hidden">
          <AccordionTrigger data-testid={`${testid}-q-${i}`}
            className="text-left font-heading font-semibold text-brand-dark hover:no-underline py-5 text-base">
            {f.question || f.q}
          </AccordionTrigger>
          <AccordionContent data-testid={`${testid}-a-${i}`} className="text-brand-muted text-sm leading-relaxed pb-5">
            {f.answer || f.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
